import CurrencyInputBase from "react-currency-input-field";
import { cn } from "../../lib";
import {
  FormControl,
  FormDescription,
  FormItem,
  FormItemProps,
  FormLabel,
  FormMessage,
} from "../form";

export function CurrencyInput({
  className,
  ...props
}: React.ComponentProps<typeof CurrencyInputBase>) {
  const { prefix = "₹", intlConfig = { locale: "en-IN", currency: "INR" } } =
    props;
  return (
    <CurrencyInputBase
      prefix={prefix}
      className={cn(
        "flex h-9 w-full px-3 py-2 text-base md:text-sm",
        "bg-background placeholder:text-muted-foreground",
        "rounded-md border border-input",
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring", // focus-visible:ring-offset-2
        "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
        className
      )}
      intlConfig={intlConfig}
      decimalsLimit={2}
      {...props}
    />
  );
}

export function FormCurrencyInput({
  ...props
}: FormItemProps<typeof CurrencyInput, string>) {
  const { label, className, description, onChange, ...rest } = props;

  const handleChange = (value?: string) => {
    onChange?.(value ?? "");
  };

  return (
    <FormItem className={className}>
      <FormLabel>{label}</FormLabel>
      <FormControl>
        <CurrencyInput {...rest} onValueChange={handleChange} type="text" />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
}
